var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:(_vm.carbonPrefix + "--side-nav__item")},[_c(_vm.tagType,_vm._g(_vm._b({tag:"component",class:[
      'cv-side-nav-item-link',
      (_vm.carbonPrefix + "--side-nav__link"),
      ( _obj = {}, _obj[(_vm.carbonPrefix + "--side-nav__link--current")] = _vm.active, _obj ) ]},'component',Object.assign({}, _vm.$attrs, _vm.linkProps),false),_vm.$listeners),[(_vm.hasNavIcon)?_c('cv-side-nav-icon',{attrs:{"small":""}},[_vm._t("nav-icon")],2):_vm._e(),_c('cv-side-nav-link-text',[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }